import { Routes } from "@angular/router";
import { authGuard } from "../../../core/guards/auth.guard";
import { DropdownSettingsPageComponent } from "./dropdown-settings-page.component";

export const dropdownSettingsPageRoutes: Routes = [
  {
    path: 'dropdown-settings',
    canActivate: [authGuard],
    component: DropdownSettingsPageComponent
  }
]
